export default __webpack_public_path__ + "static/media/blog7.8230784a.png";